import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from './store/store'
import { AuthGate, AUTH_ENABLED } from './auth'
import Sidebar from './components/layout/Sidebar'

const TokenUpdater = lazy(() => import('./auth/TokenUpdater'))
import Header from './components/layout/Header'
import StatusBar from './components/layout/StatusBar'
import MobileNav from './components/layout/MobileNav'
import ImageModal from './components/library/ImageModal'
import { SearchResultsPanel, RegionSelector } from './components/search'
import LibraryPage from './pages/LibraryPage'
import AlbumsPage from './pages/AlbumsPage'
import AlbumDetailPage from './pages/AlbumDetailPage'
import FacesPage from './pages/FacesPage'
import FilesPage from './pages/FilesPage'
import AdminPage from './pages/AdminPage'
import SettingsPage from './pages/SettingsPage'

function App() {
  const sidebarOpen = useSelector((state: RootState) => state.ui.sidebarOpen)

  return (
    <AuthGate>
      {/* Token bridge: syncs Auth0 token getter to singleton store for RTK Query */}
      {AUTH_ENABLED && <Suspense fallback={null}><TokenUpdater /></Suspense>}

      <div className="flex h-screen overflow-hidden">
        {/* Desktop Sidebar */}
        <div className={`hidden md:block transition-all duration-300 ${sidebarOpen ? 'w-sidebar' : 'w-0'}`}>
          <Sidebar />
        </div>

        {/* Mobile Navigation */}
        <MobileNav />

        {/* Main Content */}
        <div className="flex-1 flex flex-col min-w-0">
          <Header />

          <main className="flex-1 overflow-auto p-4">
            <Routes>
              <Route path="/" element={<Navigate to="/library" replace />} />
              <Route path="/library" element={<LibraryPage />} />
              <Route path="/files" element={<FilesPage />} />
              <Route path="/albums" element={<AlbumsPage />} />
              <Route path="/albums/:id" element={<AlbumDetailPage />} />
              <Route path="/faces" element={<FacesPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/settings" element={<SettingsPage />} />
            </Routes>
          </main>

          <StatusBar />
        </div>

        {/* Full-size image modal */}
        <ImageModal />

        {/* Search results panel (slides in from right) */}
        <SearchResultsPanel />

        {/* Region selection overlay */}
        <RegionSelector />
      </div>
    </AuthGate>
  )
}

export default App
